export type FormErrorType =
  | 'validate'
  | 'required'
  | 'pattern'
  | 'minLength'
  | 'maxLength'
  | 'min'
  | 'max'
  | 'value'
  | 'setValueAs'
  | 'shouldUnregister'
  | 'onChange'
  | 'onBlur'
  | 'disabled'
  | 'deps'
  | 'pattern'
  | 'valueAsNumber'
  | 'valueAsDate';

/**
 * Checks if the error type is a standard form validation error
 * @param errorType - The type of error to check
 * @returns boolean indicating if it's a standard form validation error
 */
export const isFormValidationError = (errorType?: string): boolean => {
  const validationErrorTypes: FormErrorType[] = [
    'validate',
    'required',
    'pattern',
    'minLength',
    'maxLength',
    'min',
    'max',
    'value',
    'setValueAs',
    'shouldUnregister',
    'onChange',
    'onBlur',
    'disabled',
    'deps',
  ];

  return validationErrorTypes.includes(errorType as FormErrorType);
};
